import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EditPoi from '../../Monitor/POI/EditPOI';
// import {BootstrapTable,TableHeaderColumn} from 'react-bootstrap-table';
import RCPagination from '../../UserControl/Pagination/RCPagination';
import { checkStatus, checkPrivileges } from '../../../../util/util';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import '../POI/css/react-bootstrap-table-all.min.css';
import $ from "jquery";
import { isRegExp } from 'util';
import { Alert } from '../../../Modals/AlertBar';
const divStyle = {
    height: "calc(100vh - (210px))"
}
let m_chkIndex = 0;
let m_isVisiblePOILayer = false;
let m_isMapClick = true;
let isUpdate = false;
class ListPOI extends Component {

    constructor() {
        super();

        this.state = {
            dataPoi: [],
            poiName: '',
            deviceSelectID: null,
            isShowEdit: false,
            isShowNew: false,
            currentPage: 1,
            currentPageSize: 10000,
            totalPage: 0,
            tableHeight: divStyle.height,
            bgColor: '',
            isVisiblePOILayer: m_isVisiblePOILayer,
            checkAllPoi: false,
            isShowPoiName:false
        };
    }

    componentDidMount() {
        // this.getPOIList();

        var ll = $("#chkVisiblePOILayer").prop("checked");
        console.log('ll',ll);
        
        if ($("#chkVisiblePOILayer").prop("checked"))
        {
            
            if (!checkPrivileges("view_poi")) {
                Alert("คุณไม่มีสิทธิ์ ดูจุดสนใจได้", "กรุณาติดต่อผู้ดูแล้วระบบ");
                return;
            }
    
    
            m_isVisiblePOILayer = $("#chkVisiblePOILayer").prop("checked");
            console.log('xxx m_isVisiblePOILayer',m_isVisiblePOILayer);
            if (this.props.onSetVisiblePOILayer && this.props.onSetVisiblePOILayer != null) {
                
                this.props.onSetVisiblePOILayer($("#chkVisiblePOILayer").prop("checked"));
                this.props.onSetVisiblePOIName($("#chkVisiblePOILayer").prop("checked"));
            }
            
            this.setState({ isVisiblePOILayer: m_isVisiblePOILayer ,isShowPoiName:m_isVisiblePOILayer})
        }
        
        this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize);
        if (this.props.onClickUpdatePOI && this.props.onClickUpdatePOI != null)
            this.props.onClickUpdatePOI(false);

        this.checkStatusPoi();

    }
    componentDidUpdate() {

        if (isUpdate) {
            $("#poiListChk" + m_chkIndex).focus();
            isUpdate = false;
        }
    }

    componentWillUnmount() {
        this.setState({ dataPoi: [], poiName: '' });
        if (this.props.onClickUpdatePOI && this.props.onClickUpdatePOI != null)
            this.props.onClickUpdatePOI(false);
    }



    onPageSelect(page) {

        //fetch http://{server}/api/admin/xxxx/{page}/{this.state.currentPageSize}
        //then this.setState({deviceList:data,currentPage:page})

        // let data=tmpdeviceList.slice((page-1)*this.state.currentPageSize,((page-1)*this.state.currentPageSize)+this.state.currentPageSize)
        // this.setState({deviceList:data,currentPage:page})
        // console.log('onPageSelect',data,(page-1)*this.state.pageSize,((page-1)*this.state.pageSize)+this.state.pageSize);
        const { currentPageSize } = this.state;
        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getPOIList/${page}/${currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                // "filter":name
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                this.setState({
                    deviceList: data.RESULT_DATA,
                    totalPage: data.RESULT_TOTAL,
                    currentPage: page, currentPageSize: currentPageSize
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }
    onPageSizeChange(page, pageSize) {
        // fetch http://{server}/api/admin/xxxx/{page}/{this.state.currentPageSize}
        // then this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})


        const name = this.state.poiName;
        const { user_id, user_name, token } = this.props;
        console.log('tokenPOI', token)
        fetch(`http://203.150.199.244/api/admin/getPOIList/${page}/${pageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                "filter": name
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                this.setState({
                    dataPoi: data.RESULT_DATA,
                    totalPage: data.RESULT_TOTAL,
                    currentPage: page, currentPageSize: pageSize
                }, () => this.checkStatusPoi())

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });



        // let data=tmpdeviceList.slice((page-1)*pageSize,((page-1)*pageSize)+pageSize)
        // this.setState({deviceList:data,currentPage:page,currentPageSize:pageSize})
        // console.log('onPageSizeChange',data)
    }

    checkStatusPoi() {

        console.log('this.state.dataPoi', this.state.dataPoi)
        let flag = true;
        this.state.dataPoi.map((i) => {

            console.log('i.is_visible', i.is_visible)
            if (i.is_visible === false)
                flag = false;
        })
        console.log('flag', flag)
        $("#checkAll").prop("checked", flag);
        // this.setState({checkAllPoi:flag})
    }

    handleChange = (event) => {
        var val = event.target.value;

        // this.state.poiName = val;
        this.setState({
            poiName: val
        });

        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    // getPOIList() {
    //     const name = this.state.poiName;
    //     const { token } = this.props;
    //     fetch("http://203.150.199.244/api/admin/getPOIList/1/20", {
    //         method: 'post',
    //         headers: {
    //             "Content-Type": "application/json; charset=utf-8",
    //            // "user_id": user_id,
    //            // "user_name": user_name,
    //            "token": token
    //         },
    //         body: JSON.stringify({
    //             "filter":name
    //         })
    //         })
    //         .then(response => response.json())
    //         .then(data => {
    //             this.setState({dataPoi:data.RESULT_DATA})

    //         })
    //         .catch(function (err) {
    //             console.log('err:', err);
    //             // POST failed...
    //         });


    //  }

    handleRowSelect1 = (row) => {
        const { onClickRowListTable } = this.props;
        onClickRowListTable(row)
    }

    // trStyle = (row, rowIndex) => {
    //     return { cursor: 'pointer'};
    // }

    editeDevice(device) {

        this.setState({
            deviceSelectID: device.device_id,
            isShowEdit: true
        })
    }

    onEditDeviceClose() {
        this.btnEditClose.click();
        this.setState({
            isShowEdit: false
        })
    }

    deleteDevice() {

    }

    onPasswordKeyPress(e){
        if (e.key === 'Enter') {
            this.onClickSearch();
        }
    }

    onClickSearch = () => {

        let name = this.state.poiName;

        this.setState({ poiName: name });
        this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize);

    }

    componentWillReceiveProps(nextProps) {

        let id = '';

        if (nextProps.poiId !== this.props.poiId) {
            id = nextProps.poiId;
            if (id != '') {
                $(".poiListTr").removeClass("table-warning");
                $("#" + id).addClass("table-warning");
                //$("#poiListChk"+id).focus();
                console.log('device.id focus', id)
                m_chkIndex = id;
                isUpdate = true;
            }

        } else {
            id = this.props.poiId;
        }
        //if(m_isMapClick )

    }


    // selectPOIByMap(){

    //     let id = this.props.poiId
    //     if(id != null){
    //         $(".poiListTr").removeClass("table-warning");
    //         $("#"+id).addClass("table-warning");
    //     }
    // }

    selectRow(device, index) {

        const { openNearList } = this.props;
        m_chkIndex = device.id;

        this.setState({ tableHeight: "calc(55vh - (210px))" });
        // let aaa = "id"+device.id;
        // var object = this.refs[`${aaa}`];
        // console.log(object,device)

        openNearList(device);

        $(".poiListTr").removeClass("table-warning");
        $("#" + device.id).addClass("table-warning");


        if (this.props.onZoomToLatLong && this.props.onZoomToLatLong != null)
            this.props.onZoomToLatLong(device.lat, device.lng);

        isUpdate = true;
    }

    changeCmb(e, device) {
        console.log('changeCmb', e, e.target.checked)
        // alert(device.id)
        this.setPOIVisible(device.id, e.target.checked)
    }

    changeCmbAll(ev) {
        console.log('ev.target.checked', ev.target.checked)
        console.log('dataPoi', this.state.dataPoi)


        if (ev.target.checked) {
            $(".ckAll").prop("checked", true);
            // $("#checkAll").attr("data-type", "uncheck");
        } else {
            $(".ckAll").prop("checked", false);
            // $("#checkAll").attr("data-type", "check");
        }
        this.state.dataPoi.map((i) => {

            console.log('poi_id', i.poi_id)
            this.setPOIVisible(i.poi_id, ev.target.checked)

        })
        // this.setState({checkAllPoi:ev.target.checked});
    }

    setPOIVisible(id, ck) {

        console.log('setPOIVisible', ck)
        const { token } = this.props;
        fetch(`http://203.150.199.244/api/admin/setPOIVisible/${id}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "isVisible": ck
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {

                if (this.props.onRefreshPOI && this.props.onRefreshPOI != null)
                    this.props.onRefreshPOI();
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onAdd = () => {
        if (!checkPrivileges("edit_poi")) {
            Alert("คุณไม่มีสิทธิ์ เพิ่มจุดสนใจได้", "กรุณาติดต่อผู้ดูแล้วระบบ");
            return;
        }
        const { openAdd } = this.props;
        this.setState({ tableHeight: "calc(55vh - (210px))" });
        openAdd();
        console.log("add", this.props.onClickUpdatePOI)
        if (this.props.onClickUpdatePOI && this.props.onClickUpdatePOI != null)
            this.props.onClickUpdatePOI(true);
    }
    handleVisiblePOILayer(e) {
        if (!checkPrivileges("view_poi")) {
            Alert("คุณไม่มีสิทธิ์ ดูจุดสนใจได้", "กรุณาติดต่อผู้ดูแล้วระบบ");
            return;
        }


        m_isVisiblePOILayer = e.target.checked;
        console.log('xxx m_isVisiblePOILayer',m_isVisiblePOILayer);
        if (this.props.onSetVisiblePOILayer && this.props.onSetVisiblePOILayer != null) {
            
            this.props.onSetVisiblePOILayer(e.target.checked);
            this.props.onSetVisiblePOIName(e.target.checked);
        }
        
        this.setState({ isVisiblePOILayer: m_isVisiblePOILayer ,isShowPoiName:m_isVisiblePOILayer})
        

    }

    handleVisiblePOIName(e) {

        if (this.props.onSetVisiblePOIName) {
            console.log("xx", e.target.checked)
            this.props.onSetVisiblePOIName(e.target.checked);
        }
    }

    render() {
        console.log('m_isVisiblePOILayer',m_isVisiblePOILayer);
        
        const { deviceSelectID, isShowNew, isShowEdit, deviceList, currentPageSize } = this.state;

        const { onClickDeletePoi, openNearList } = this.props;
        console.log(this.state.dataPoi)
        const flattenData = this.state.dataPoi.map((item, key) => {

            return {
                no: key + 1,
                id: item.poi_id,
                name: item.name,
                group: item.group,
                radius: item.radius,
                lat: item.location.latitude,
                lng: item.location.longitude,
                is_visible: item.is_visible,
                // email:item.alert.email,
                // line_token:item.alert.line_token,
                // is_entry:item.alert.when.is_entry,
                // is_leave:item.alert.when.is_leave,
                icon: item.icon,

            };
        });

        let rows = [];
        flattenData.map((device, key) => {
            rows.push(
                <tr key={device.id}>
                    <td >{key + 1}</td>
                    <td ><input type="checkbox" value="" /></td>
                    <td>{device.name}</td>
                    <td style={{ textAlign: 'center' }}>{device.radius}</td>
                    {/* <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Edit">
                    <button onClick={this.handleRowSelect1.bind(this, device)} className="btn btn-primary btn-xs" data-title="Edit" data-toggle="modal"
                    data-target="#editDevice"  data-backdrop="static" data-keyboard="false"><span className="fa fa-pencil" /></button></p></td>
                    
                <td><p data-placement="top" data-toggle="tooltip" title="Delete">
                <button  onClick={(e) => { e.preventDefault(); onClickDeletePoi(device); }}  className="btn btn-danger btn-xs" data-title="Delete" data-toggle="modal"
                data-target="#deleteDevice" data-backdrop="static" data-keyboard="false"><span className="fa fa-trash" /></button></p></td> */}

                </tr>
            )

        });

        return (


            <div className="gray-panel">

                <div className="form-group row">
                    <div className=" col-12 col-sm-8 col-md-8">
                        {/* <input className="form-control col-md-6 form-control-sm" type="text" onChange={this.handleChange} />
                    <button type="button" className="btn btn-info  btn-sm" onClick={this.onClickSearch}>
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </button> */}
                        <div class="input-group">
                            <input className="form-control col-md-10 form-control-sm" type="text" onChange={this.handleChange} onKeyup={this.handleChange}  onKeyPress={this.onPasswordKeyPress.bind(this)} />
                            <div class="input-group-append">
                                <button type="button" className="btn btn-info  btn-sm" onClick={this.onClickSearch}>
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                </button>
                            </div>




                        </div>
                        <div style={{ marginTop: '1rem' }}>
                            <label className=" col-form-label " for="chkVisiblePOILayer" style={{ display: "inline" }}>
                                <input type="checkbox" id="chkVisiblePOILayer" checked={m_isVisiblePOILayer} onChange={(e) => { this.handleVisiblePOILayer(e) }} />
                                แสดง POI
                            </label>&nbsp;&nbsp;
                            {
                                this.state.isShowPoiName &&
                                <label className=" col-form-label " for="chkVisiblePOIName" style={{ display: "inline" }}>
                                    <input type="checkbox" className="chkVisiblePOIName" defaultChecked id="chkVisiblePOIName" onChange={(e) => { this.handleVisiblePOIName(e) }} />
                                    แสดงชื่อ POI
                                </label>
                            }

                        </div>
                    </div>

                    <div className="col-12 col-sm-4 col-md-4 text-right">
                        <input style={{ width: 80 }} className="btn btn-primary btn-sm" id="focusedInput" type="button" value="เพิ่ม POI" onClick={this.onAdd} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-12 table-responsive" style={{ maxHeight: this.state.tableHeight, overflowY: "auto" }}>
                        <table className="table table-bordred table-striped table-hover ">
                            <thead >
                                <tr>
                                    <th style={{ width: 20 }}></th>
                                    <th style={{ width: 20 }}>
                                        <input type="checkbox" id="checkAll" onChange={(ev) => { this.changeCmbAll(ev) }} defaultChecked={this.state.checkAllPoi} />
                                    </th>
                                    <th>ชื่อสถานที่</th>
                                    <th>รัศมี</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    flattenData.map((device, key) => {

                                        return (
                                            <tr key={device.id} id={device.id} ref={"id" + device.id} className="poiListTr" onClick={this.selectRow.bind(this, device, key)} style={{ cursor: 'pointer', background: this.state.bgColor }}>
                                                <td >{key + 1}</td>
                                                <td >
                                                    <input type="checkbox" className="ckAll" id={"poiListChk" + device.id} defaultChecked={device.is_visible}
                                                        onChange={(e) => { this.changeCmb(e, device) }} />
                                                </td>
                                                <td>{device.name}</td>
                                                <td style={{ textAlign: 'center' }}>{device.radius}</td>

                                            </tr>
                                        )

                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* <BootstrapTable data={ flattenData } options={ options } striped hover condensed
                bodyStyle={ onmouseOver } 
                selectRow={ selectRowProp }
                
            >
                <TableHeaderColumn isKey={true} dataField='no' width='25'></TableHeaderColumn>
                <TableHeaderColumn dataField='name' >ชื่อสถานที่</TableHeaderColumn>
                <TableHeaderColumn dataField='radius'  width='50'>รัศมี</TableHeaderColumn>
            </BootstrapTable> */}
                {/* <RCPagination onSelect={this.onPageSelect.bind(this)} onShowSizeChange={this.onPageSizeChange.bind(this)} total={this.state.totalPage} pageSize={currentPageSize}/> */}
            </div>
        );
    }
}

ListPOI.propTypes = {
    onClickRowListTable: PropTypes.func.isRequired,
    userLevel: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onClickCancelEditPoi: PropTypes.func.isRequired,
    onClickConfirmEditPoi: PropTypes.func.isRequired,
    onClickDeletePoi: PropTypes.func.isRequired,
    openAdd: PropTypes.func,
    openEdit: PropTypes.func,
    openNearList: PropTypes.func,
    poiId: PropTypes.string,
    onRefreshPOI: PropTypes.func
}

export default ListPOI;



// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/POI/ListPOI.js